import { render, staticRenderFns } from "./cooperate.vue?vue&type=template&id=d6dbf948&scoped=true&"
import script from "./cooperate.vue?vue&type=script&lang=js&"
export * from "./cooperate.vue?vue&type=script&lang=js&"
import style0 from "./cooperate.vue?vue&type=style&index=0&id=d6dbf948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6dbf948",
  null
  
)

export default component.exports